<template>
	<div>
		<div class="add-event-step-header">What should your guests bring?</div>
		<v-checkbox v-model="laptop" label="Laptop"></v-checkbox>
		<v-checkbox v-model="headphones" label="Headphones"></v-checkbox>
		<v-checkbox v-model="notebook" label="Notebook"></v-checkbox>
		<v-checkbox v-model="yogaMat" label="Yoga Mat"></v-checkbox>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			laptop: false,
			headphones: false,
			notebook: false,
			yogaMat: false
		}
	},
	beforeRouteLeave(to, from, next) {
		console.log('leaving page')
		next()
	},
	methods: {
		...mapActions(['setAddEventWrkprtyType'])
	},
	computed: {
		...mapGetters(['getAddEventWrkprtyType']),
		typeSelection: {
			get() {
				return this.getAddEventWrkprtyType
			},
			set(val) {
				this.setAddEventWrkprtyType(val)
			}
		}
	}
}
</script>

<style>
</style>
